<!-- Spinner while catalog is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading service items. Click below try again.
    <button hc-button size="lg" (click)="loadPartners()">Reload 3<sup>rd</sup>Party Technology</button>
</div>

<div class="admin-product-catalog-table-container" [hidden]="loadError || loading">
    <h2>
        <span>
            <hc-icon fontSet="fa" fontIcon="fa-handshake-o" class="handshake-icon"></hc-icon>
            3<sup>rd</sup>Party Technology
        </span>
        <div>
            <button hc-button routerLink="/admin/partners/editor">Add 3<sup>rd</sup>Party</button>
        </div>
    </h2>
    <div class="admin-product-catalog-control-bar">
        <div class="admin-product-catalog-filters">
            <div class="filter-dropdown" title="Filter by product status">
                <label for="productStatus">Status</label>
                <button hc-button buttonStyle="link-inline" id="productStatus" [hcPop]="filtermenu"
                    (click)="storeFilterData('status')" [context]="statusFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ statusText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by publish status">
                <label for="publishedStatus">Publish Status</label>
                <button hc-button buttonStyle="link-inline" id="publishedStatus" [hcPop]="filtermenu"
                    (click)="storeFilterData('published')" [context]="publishStatusFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ publishStatusText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                    (filterChecked)="storeFilterArray($event)"></filter-popover>
            </hc-pop>
        </div>
        <div class="control-bar-right">
            <hc-search-bar #searchbar placeholder="Search partners" (triggerSearch)="applySearchFilter($event)"
                class="admin-product-catalog-search"></hc-search-bar>
        </div>
    </div>
    <table hc-table [borders]="false" class="admin-product-catalog-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="item">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="item">ID</th>
            <td hc-index-cell *hcCellDef="let element" routerLink="/admin/partners/editor" [queryParams]="{id: element.partnerID}">{{ element.item }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/partners/editor" [queryParams]="{id: element.partnerID}">{{ element.name }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container hcColumnDef="status">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="statusHeader">Status</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/partners/editor" [queryParams]="{id: element.partnerID}">{{ element.status }}</td>
        </ng-container>

        <!-- Revision Date Column -->
        <ng-container hcColumnDef="revisionDate">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="revisionDateHeader">Revision Date</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/partners/editor" [queryParams]="{id: element.partnerID}">{{ element.revisionDate | date: 'shortDate' }}</td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center"> 
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span hcMenuIcon class="fa fa-pencil hc-action-ico" hcTooltip="Edit partner"
                        routerLink="/admin/partners/editor" [queryParams]="{id: element.partnerID}"></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminPartnersDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminPartnersDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No partners meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminPartnersListLength" [pageSize]="adminPartnersPageSize"
        [hidden]="loadError || loading"></hc-pagination>
</div>